import React, { useCallback, useEffect } from "react"
import { mixed, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import AppProvidersAutocomplete from "@components/Autocomplete/Providers"
import { BACKEND_APIS } from "@constants"
import { autoEuropeProviderNormalizationDrawerData, autoEuropeProviderNormalizationDrawerErrors } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

export default function AutoEuropeProviderNormalizationProviderField() {
	const value = autoEuropeProviderNormalizationDrawerData.value.provider ?? null

	const { errors, isValid } = useValidatorSeeker({ provider: value }, object({
		provider: mixed().required("Provider is required"),
	}))

	useEffect(() => {
		autoEuropeProviderNormalizationDrawerErrors.value = { ...autoEuropeProviderNormalizationDrawerErrors.value, provider: isValid }
	}, [JSON.stringify(errors)])

	const onChange = useCallback((e, option) => {
		const current = autoEuropeProviderNormalizationDrawerData.value
		const selectedProvider = e.target.value
		const shouldAutofill = !current._isEditing && !current.autoEuropeProvider && option?.label
		autoEuropeProviderNormalizationDrawerData.value = {
			...current,
			provider: selectedProvider,
			...(shouldAutofill && { autoEuropeProvider: option.label.toUpperCase() }),
		}
	}, [])

	return <AppProvidersAutocomplete
		multiple={false}
		urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/providers`}
		value={value?.value ?? value}
		onChange={onChange}
		error={errors?.provider}
		formatOptionLabel={({ label }) => label?.toUpperCase()}
		getOptionLabel={option => option?.label?.toUpperCase() ?? ''}
	/>
}